import React, { Component } from 'react';

import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch
} from 'react-router-dom'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import { Provider } from 'react-redux'
import { createStore } from 'redux'
import TheFyzz from './reducers/TheFyzz'
import FilmsPage from './modules/pages/FilmsPage'
import FilmDetailPage from './modules/pages/FilmDetailPage'
import MainMenu from './modules/menu/MainMenu'
import Error404 from './modules/pages/Error404'
import StandardPage from './modules/pages/StandardPage'
import LandingPage from './modules/pages/LandingPage'
import Logo from './modules/misc/Logo'
import GoogleAnalytics from './modules/misc/GoogleAnalytics'






let store =  createStore(TheFyzz)

class App extends Component {

  constructor(){
    super();
    this.logPageView = this.logPageView.bind(this)
  }

  logPageView(){

  }

  componentWillUpdate(){
    console.log(this);
  }


  render() {

      let animationTime = 4

    return (
       <Provider store={store}>


        <Router>
          <div>


            <Logo></Logo>
            <MainMenu>
              <ReactCSSTransitionGroup
                transitionName="fade"
                transitionEnterTimeout={animationTime}
                transitionLeaveTimeout={animationTime}
                transitionAppear={true}
                transitionAppearTimeout={animationTime}
              >

                  <Switch>
                        <Redirect from='/facility/team/' to='/team'/>
                        <Redirect from='/facility/about/' to='/about'/>
                        <Redirect from='/facility/projects/' to='/projects'/>
                        <Redirect from='/facility/contact/' to='/'/>


                        <Route exact path="/" component={LandingPage}></Route>
                        <Route exact path="/projects" component={FilmsPage} />
                        <Route path="/project/:currentfilm" component={FilmDetailPage}/>
                        <Route path="/:page" component={StandardPage}/>



                        <Route component={Error404}/>

                  </Switch>
              </ReactCSSTransitionGroup>

          </MainMenu>

          <GoogleAnalytics />
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js